module.exports = __webpack_public_path__ + "img/choose-up-cadou.3926f9dc.png";